import React from 'react';
import {queryTagRoute} from '../../../constants/public-routes';
import Link from '../../routing/components/Link';

class TagGroup extends React.Component {
  render() {
    let language = this.props.language;

    this.props.items.sort((a, b) => {
      return a.attributes.pref[language].toLowerCase() < b.attributes.pref[language].toLowerCase() ? -1 : +1;
    });
    let links = [];
    this.props.items.map(function (item) {
      let text = item.attributes.pref[language];
      let url = queryTagRoute(language, text);
      links.push(<div key={url}><Link url={url}>{text}</Link></div>);
    });
    return (
      <div>
        <strong id={this.props.groupId}>{this.props.char.toUpperCase()}</strong>
        <div className="newspaper-columns">
          {links}
        </div>
      </div>
    );
  }

}

TagGroup.propTypes = {
  language: React.PropTypes.string.isRequired,
  items: React.PropTypes.array,
  char: React.PropTypes.string.isRequired,
  groupId: React.PropTypes.string,
};

export default TagGroup;



/** WEBPACK FOOTER **
 ** ./src/modules/tags/components/TagGroup.js
 **/